import { render, staticRenderFns } from "./CommentsPost.vue?vue&type=template&id=000403d1"
import script from "./CommentsPost.vue?vue&type=script&lang=js"
export * from "./CommentsPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000403d1')) {
      api.createRecord('000403d1', component.options)
    } else {
      api.reload('000403d1', component.options)
    }
    module.hot.accept("./CommentsPost.vue?vue&type=template&id=000403d1", function () {
      api.rerender('000403d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/CommentsPost.vue"
export default component.exports